module.exports = __webpack_public_path__ + "img/16.64cd3812.png";